import { urlify } from '../../utils/string';

const selectAnalytics = (item, setup, currentView, itemIndex) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const itemCategory = item.canonicalUri.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'select_item',
		ecommerce: {
			items: [{
				item_name: item.name,
				item_id: item.groupId,
				price: item.price.priceAsNumber,
				currency: setup.countries[setup.country].currency,
				item_brand: item.brandName,
				...itemCategory,
				item_variant: item.variantName,
				item_list_id: urlify(currentView),
				item_list_name: currentView,
				index: `${itemIndex}`,
				quantity: '1',
			}],
		},
	});
};

export default selectAnalytics;
